import React from 'react';
import {Card, Typography, Button} from '@material-ui/core'
import { useHistory } from 'react-router-dom';

export default function FaltuRoom() {
    var history = useHistory()
    const goHome =()=>{
        history.push('/')
    }
  return (
    <div style={{display:'flex', justifyContent:'center', alignItems:'center', flexDirection: 'column'}}>
        <Card style={{margin: '30px', padding:'30px'}}>
            <Typography>
                404 Not Found
            </Typography>

        </Card>
        <Button variant="contained" color="primary" onClick={goHome}>Go Home</Button>
    </div>
  );
}